// extracted by mini-css-extract-plugin
module.exports = {"inlineAdWrapper":"Tw-z","microsoftAdsWrapper":"Uw-z","marketplaceRecosWrapper":"Vw-z"};